module.exports = __webpack_public_path__ + "img/insurancebg-1.5749cc24.jpg";